var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C17.1112 20 18.0556 19.6112 18.8334 18.8334C19.6112 18.0556 20 17.1112 20 16C20 14.8889 19.6112 13.9445 18.8334 13.1667C18.0556 12.3889 17.1112 12 16 12C14.8889 12 13.9445 12.3889 13.1667 13.1667C12.3889 13.9445 12 14.8889 12 16C12 17.1112 12.3889 18.0556 13.1667 18.8334C13.9445 19.6112 14.8889 20 16 20ZM16 22.6667C14.1556 22.6667 12.5834 22.0167 11.2834 20.7167C9.98337 19.4167 9.33337 17.8445 9.33337 16C9.33337 14.1556 9.98337 12.5834 11.2834 11.2834C12.5834 9.98337 14.1556 9.33337 16 9.33337C17.8445 9.33337 19.4167 9.98337 20.7167 11.2834C22.0167 12.5834 22.6667 14.1556 22.6667 16C22.6667 17.8445 22.0167 19.4167 20.7167 20.7167C19.4167 22.0167 17.8445 22.6667 16 22.6667ZM6.66671 17.3334H1.33337V14.6667H6.66671V17.3334ZM30.6667 17.3334H25.3334V14.6667H30.6667V17.3334ZM14.6667 6.66671V1.33337H17.3334V6.66671H14.6667ZM14.6667 30.6667V25.3334H17.3334V30.6667H14.6667ZM8.53337 10.3334L5.16671 7.10004L7.06671 5.13337L10.2667 8.46671L8.53337 10.3334ZM24.9334 26.8667L21.7 23.5L23.4667 21.6667L26.8334 24.9L24.9334 26.8667ZM21.6667 8.53337L24.9 5.16671L26.8667 7.06671L23.5334 10.2667L21.6667 8.53337ZM5.13337 24.9334L8.50004 21.7L10.3334 23.4667L7.10004 26.8334L5.13337 24.9334Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.e7cb7f537e55ffae9851f455ba439c12.svg";
export { ForwardRef as ReactComponent };